import { Link } from "react-router-dom";
import usePageMeta from "@/hooks/usePageMeta";
import MovieCard from "@/components/feature/MovieCard";
import { useFavorites } from "@/hooks/useFavorites";
import { allMovies } from "@/lib/movieData";

export default function Favorites() {
  const { favorites, removeFavorite, ready } = useFavorites();

  usePageMeta({
    title: "我的收藏 - 最近中文字幕",
    description:
      "查看你在最近中文字幕收藏的影视作品。收藏记录保存在浏览器本地，清除浏览器数据后会一并删除。",
    keywords: "最近中文字幕,我的收藏,影视收藏,中文字幕影视",
  });

  const items = favorites
    .map((id) => allMovies.find((movie) => movie.id === id))
    .filter(Boolean) as typeof allMovies;

  return (
    <div className="w-full px-4 md:px-6 py-8 md:py-10">
      <header className="mb-6 md:mb-8">
        <h1 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          <i className="ri-bookmark-3-line text-accent-500"></i>
          我的收藏
        </h1>
        <p className="mt-2 text-sm text-foreground-600">
          共收藏 {items.length} 部作品。收藏记录仅保存在当前浏览器本地存储中，清除浏览器数据后将不再保留。
        </p>
      </header>

      {!ready ? (
        <div className="py-20 text-center text-sm text-foreground-500">正在读取收藏…</div>
      ) : items.length === 0 ? (
        <div className="rounded-lg border border-dashed border-background-300 bg-background-50 py-20 text-center">
          <i className="ri-bookmark-3-line text-5xl text-foreground-300"></i>
          <h2 className="mt-4 font-heading text-lg font-bold text-foreground-950">
            还没有收藏任何作品
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            在作品详情页点击「收藏」，即可在这里快速找到它。
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link
              to="/category/movie"
              className="rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 dark:text-foreground-950 whitespace-nowrap"
            >
              浏览电影
            </Link>
            <Link
              to="/category/tv"
              className="rounded-md border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-700 whitespace-nowrap"
            >
              浏览电视剧
            </Link>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((movie) => (
            <div key={movie.id} className="relative">
              <MovieCard movie={movie} variant="wide" />
              <button
                type="button"
                onClick={() => removeFavorite(movie.id)}
                className="absolute right-3 top-3 w-8 h-8 flex items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-500 transition-colors hover:border-accent-300 hover:text-accent-600"
                aria-label={`取消收藏 ${movie.title}`}
              >
                <i className="ri-close-line text-lg"></i>
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}